import { render } from "./BuildSpokeNav.vue?vue&type=template&id=6d90bd7b&scoped=true"
import script from "./BuildSpokeNav.vue?vue&type=script&lang=js"
export * from "./BuildSpokeNav.vue?vue&type=script&lang=js"

import "./BuildSpokeNav.vue?vue&type=style&index=0&id=6d90bd7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d90bd7b"]])

export default __exports__